import { JSX } from 'react';
import { Alert, AlertTitle, Badge, Button, Flex } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateExclamation } from '@fortawesome/pro-regular-svg-icons';

type Props = {
  onDetailsClick: () => void;
};
export function DuplicatesAlert({ onDetailsClick }: Props): JSX.Element {
  return (
    <Alert status="error" mb="4">
      <Flex width={'100%'} justifyContent="space-between" alignItems="center" gap={4}>
        <Flex alignItems="center" gap={3}>
          <Badge p={1} borderRadius="full" variant="solid" colorScheme="red">
            <FontAwesomeIcon size="sm" color="white" icon={faRotateExclamation} />
          </Badge>
          <AlertTitle>Potential duplicates on your student management system</AlertTitle>
        </Flex>

        <Button variant="solid" onClick={onDetailsClick} flexShrink={0}>
          Details
        </Button>
      </Flex>
    </Alert>
  );
}
